// Generated by Claude Code
import { Api, MAX_PAGE_SIZE } from '#core/api/Api.ts'
import CompanyAccessRequest from '#core/entities/auth/companies/access-requests/CompanyAccessRequest.ts'
import OwnCompanyAccessRequest from '#core/entities/auth/companies/access-requests/OwnCompanyAccessRequest.ts'
import type { BaseIdModel } from '#core/entities/shared/BaseModels.ts'
import type { QueryResult, SingleQueryConfig } from '#core/entities/shared/Query.ts'

/**
 * Requests to join a company, filed by a first SSO sign-in. `listMine` needs no company;
 * the rest is company-scoped and gated on the users update grant.
 */
export default class CompanyAccessRequestsApi extends Api<CompanyAccessRequestsApi> {
  constructor() {
    super()
  }

  /** The signed-in user's own requests, newest first. */
  async listMine(): Promise<OwnCompanyAccessRequest[]> {
    return (await this.get<OwnCompanyAccessRequest[]>('auth/company-access-requests/mine', undefined, OwnCompanyAccessRequest)) ?? []
  }

  /** The current company's requests; the endpoint takes one filter and one sort. */
  async list(query: SingleQueryConfig = {}): Promise<QueryResult<CompanyAccessRequest>> {
    const skip = query.skip ?? 0
    const take = query.take ?? MAX_PAGE_SIZE
    const sort = this.getSingleSort(query)
    const result = await this.get<QueryResult<BaseIdModel>>('auth/company-access-requests/', {
      skip,
      take,
      ...this.singleFilterGetParams(this.getSingleFilter(query)),
      sort_property: sort?.property,
      sort_direction: sort?.direction,
    })
    return this.toQueryResult({ skip, take }, result, CompanyAccessRequest)
  }

  /** Makes the requester a member; without `roleId` they start with no permissions. */
  async approve(id: string, roleId?: string | null): Promise<CompanyAccessRequest | null> {
    return this.post<CompanyAccessRequest>(
      `auth/company-access-requests/${id}/approve`,
      roleId ? { role_id: roleId } : undefined,
      CompanyAccessRequest,
    )
  }

  async reject(id: string): Promise<CompanyAccessRequest | null> {
    return this.post<CompanyAccessRequest>(`auth/company-access-requests/${id}/reject`, undefined, CompanyAccessRequest)
  }
}
